import EventEmitter from './EventEmitter'
import * as THREE from 'three'

export default class Time extends EventEmitter {
  constructor() {
    //retrieve from EvenEmitter
    super()

    //options
    this.time = Date.now()
    this.current = this.start
    this.elpased = 0
    this.delta = 0

    //time clock
    this.clock = new THREE.Clock()

    window.requestAnimationFrame(this.tick.bind(this))
  }
  tick() {
    this.elpasedTime = this.clock.getElapsedTime()

    const currentTime = Date.now()
    this.delta = currentTime - this.current
    this.current = currentTime
    this.elpased = this.current - this.start

    this.trigger('tick')

    window.requestAnimationFrame(this.tick.bind(this))
  }
}
